// Il tipo di push che un'attività vuole ricevere da un canale Pushover (2026-10-31): priorità
// (fino all'emergenza, che si ripete finché non la confermi) e suono. Vuoti: li sceglie il pop.
// Il server li impone a ogni push dell'attività verso quei destinatari (poptown.native.Channel).
import { Select } from '../../components/Select';
import type { RoutineNotify } from '../../lib/api';

// i suoni di Pushover (https://pushover.net/api#sounds), come poptown.native.pushover.SOUNDS
const SOUNDS: [string, string][] = [
  ['pushover', 'Pushover'],
  ['bike', 'Bike'],
  ['bugle', 'Bugle'],
  ['cashregister', 'Cash Register'],
  ['classical', 'Classical'],
  ['cosmic', 'Cosmic'],
  ['falling', 'Falling'],
  ['gamelan', 'Gamelan'],
  ['incoming', 'Incoming'],
  ['intermission', 'Intermission'],
  ['magic', 'Magic'],
  ['mechanical', 'Mechanical'],
  ['pianobar', 'Piano Bar'],
  ['siren', 'Siren'],
  ['spacealarm', 'Space Alarm'],
  ['tugboat', 'Tug Boat'],
  ['alien', 'Alien Alarm (lungo)'],
  ['climb', 'Climb (lungo)'],
  ['persistent', 'Persistent (lungo)'],
  ['echo', 'Pushover Echo (lungo)'],
  ['updown', 'Up Down (lungo)'],
  ['vibrate', 'Solo vibrazione'],
  ['none', 'Nessun suono'],
];

const PRIORITIES: [string, string][] = [
  ['', 'La sceglie il pop'],
  ['-2', 'Silenziosa (nessun avviso)'],
  ['-1', 'Bassa (senza suono)'],
  ['0', 'Normale'],
  ['1', 'Alta (anche nelle ore di silenzio)'],
  ['2', 'Emergenza (si ripete finché non confermi)'],
];

export function PushStyle({
  value,
  onChange,
}: {
  value: RoutineNotify;
  onChange: (v: RoutineNotify) => void;
}) {
  return (
    <div className="push-style">
      <div style={{ display: 'grid', gap: 6 }}>
        <span className="t-caption dim">Priorità</span>
        <Select
          label="Priorità delle push"
          width="100%"
          value={value.priority == null ? '' : String(value.priority)}
          options={PRIORITIES.map(([v, label]) => ({ value: v, label }))}
          onChange={(v) => onChange({ ...value, priority: v === '' ? null : Number(v) })}
        />
      </div>
      <div style={{ display: 'grid', gap: 6 }}>
        <span className="t-caption dim">Suono</span>
        <Select
          label="Suono delle push"
          width="100%"
          value={value.sound ?? ''}
          options={[
            { value: '', label: 'Quello del destinatario' },
            ...SOUNDS.map(([v, label]) => ({ value: v, label })),
          ]}
          onChange={(v) => onChange({ ...value, sound: v || null })}
        />
      </div>
      {value.priority === 2 && (
        <span className="t-caption faint push-style-note">
          Ogni push di questa attività sarà un'emergenza: suona ogni minuto per un'ora, finché non
          la confermi sul telefono.
        </span>
      )}
    </div>
  );
}
